(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90259],{

/***/ 53211:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alquiler-temporal/[...categories]",
      function () {
        return __webpack_require__(22941);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ error; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(42648);
// EXTERNAL MODULE: ./components/atoms/text/index.ts + 1 modules
var atoms_text = __webpack_require__(36558);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(74388);
// EXTERNAL MODULE: ./components/atoms/button/types.ts
var types = __webpack_require__(90891);
// EXTERNAL MODULE: ./lib/routes/index.ts
var routes = __webpack_require__(98729);
;// CONCATENATED MODULE: ./components/organisms/banner-error/BannerError.tsx





/**
 * BannerError
 */ const BannerError = (param)=>/*#__PURE__*/ {
    let { className ="" , overlay , backgroundImage , title , description , showReloadButton =false  } = param;
    return (0,jsx_runtime/* jsx */.tZ)(container/* default */.Z, {
        classNameWrapper: "w-full min-h-[350px] lg:min-h-[640px] flex flex-col justify-center items-center",
        className: className,
        backgroundImage: backgroundImage,
        wrapper: true,
        overlay: overlay,
        align: "center",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "flex flex-col items-center text-center xs:max-w-[490px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(atoms_text/* default */.Z, {
                    className: "text-headline text-headline--h2 mb-2 text-neutrals-0",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(atoms_text/* default */.Z, {
                    className: "text-body text-body--l mb-6 text-neutrals-0",
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex flex-col gap-6 md:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                            href: routes/* routes.index */._.index,
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(atoms_button/* default */.Z, {
                                as: "span",
                                size: types/* ButtonSize.MEDIUM */.q.MEDIUM,
                                variant: types/* ButtonVariant.ELEVATED */.W.ELEVATED,
                                children: "Ir a inicio"
                            })
                        }),
                        showReloadButton && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(atoms_button/* default */.Z, {
                            outline: true,
                            size: types/* ButtonSize.MEDIUM */.q.MEDIUM,
                            variant: types/* ButtonVariant.ELEVATED */.W.ELEVATED,
                            onClick: ()=>location.reload(),
                            children: "Volver a cargar"
                        })
                    ]
                })
            ]
        })
    });
};
BannerError.displayName = "BannerError";

;// CONCATENATED MODULE: ./components/organisms/banner-error/index.ts

/* harmony default export */ var banner_error = (BannerError);

;// CONCATENATED MODULE: ./components/templates/error/Error.tsx


/**
 * Error
 */ const Error = (param)=>{
    let { className ="" , statusCode  } = param;
    return statusCode === 404 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(banner_error, {
        description: "Puede que el enlace que has seguido no sea correcto o que la p\xe1gina haya sido eliminada",
        overlay: 0.4,
        title: "Lo sentimos, esta p\xe1gina no est\xe1 disponible",
        backgroundImage: "/assets/images/background-bannererror.jpg",
        className: className
    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(banner_error, {
        description: "Pero estamos trabajando en ello para resolverlo lo antes posible.",
        overlay: 0.4,
        title: "\xa1Vaya! Parece que ha habido un problema",
        backgroundImage: "/assets/images/background-bannererror.jpg",
        showReloadButton: true,
        className: className
    });
};
Error.displayName = "Error";

;// CONCATENATED MODULE: ./components/templates/error/index.ts

/* harmony default export */ var error = (Error);


/***/ }),

/***/ 22941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9602);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37682);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37140);



const FlatCategory = (param)=>{
    let { serverState , defaultArea , errorCode , initialUiState , page: { minBookingDays , attributes: { Content: dynamicContent  }  }  } = param;
    return errorCode === 404 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_templates__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        statusCode: errorCode
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_templates__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                defaultArea: defaultArea,
                serverState: serverState,
                type: "MED_EST",
                typeText: "de alquiler temporal",
                initialUiState: initialUiState,
                minBookingDays: minBookingDays
            }),
            dynamicContent === null || dynamicContent === void 0 ? void 0 : dynamicContent.map((param, index)=>/*#__PURE__*/ {
                let { __typename , ...props } = param;
                return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_templates__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    type: __typename,
                    ...props,
                    key: "".concat(__typename, "-").concat(index)
                });
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (FlatCategory);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92456,21894,18866,61122,37140,37682,92888,40179], function() { return __webpack_exec__(53211); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);